import { isNil } from 'ramda';

import yup from 'utils/yup';

const validationSchema = yup.object().shape({
  videos: yup.array().of(
    yup.object().shape({
      name: yup.string().nullable().notRequired(),
      link: yup
        .string()
        .nullable()
        .videoURL()
        .when('name', {
          is: (val) => !isNil(val),
          then: yup.string().nullable().required(),
          otherwise: yup.string().nullable().notRequired(),
        }),
    }),
  ),
  webinars: yup.array().of(
    yup.object().shape({
      name: yup.string().nullable().notRequired(),
      link: yup
        .string()
        .nullable()
        .videoURL()
        .when('name', {
          is: (val) => !isNil(val),
          then: yup.string().nullable().required(),
          otherwise: yup.string().nullable().notRequired(),
        }),
    }),
  ),
  bookingUrl: yup.string().url().nullable(),
});

export default validationSchema;
